/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateUsertrainingDto } from '../models/work-create-usertraining-dto';
import { WorkUpdateUsertrainingDto } from '../models/work-update-usertraining-dto';
import { WorkUsertraining } from '../models/work-usertraining';

@Injectable({ providedIn: 'root' })
export class WorkUsertrainingsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usertrainingsV2ControllerFindByUserId()` */
  static readonly UsertrainingsV2ControllerFindByUserIdPath = '/v2/usertrainings/byUserId/{userId}';

  /**
   * Required permissions: usertrainings:read, usertrainings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usertrainingsV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  usertrainingsV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUsertraining>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsertrainingsV2Service.UsertrainingsV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUsertraining>>;
      })
    );
  }

  /**
   * Required permissions: usertrainings:read, usertrainings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usertrainingsV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usertrainingsV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkUsertraining>> {
    return this.usertrainingsV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUsertraining>>): Array<WorkUsertraining> => r.body)
    );
  }

  /** Path part for operation `usertrainingsV2ControllerDelete()` */
  static readonly UsertrainingsV2ControllerDeletePath = '/v2/usertrainings/{id}';

  /**
   * Required permissions: usertrainings:delete, usertrainings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usertrainingsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  usertrainingsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsertrainingsV2Service.UsertrainingsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: usertrainings:delete, usertrainings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usertrainingsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usertrainingsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.usertrainingsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `usertrainingsV2ControllerUpdate()` */
  static readonly UsertrainingsV2ControllerUpdatePath = '/v2/usertrainings/{id}';

  /**
   * Required permissions: usertrainings:update, usertrainings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usertrainingsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usertrainingsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateUsertrainingDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsertrainingsV2Service.UsertrainingsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: usertrainings:update, usertrainings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usertrainingsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usertrainingsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateUsertrainingDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.usertrainingsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usertrainingsV2ControllerCreate()` */
  static readonly UsertrainingsV2ControllerCreatePath = '/v2/usertrainings';

  /**
   * Required permissions: usertrainings:create, usertrainings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usertrainingsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usertrainingsV2ControllerCreate$Response(
    params: {
      body: WorkCreateUsertrainingDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsertrainingsV2Service.UsertrainingsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Required permissions: usertrainings:create, usertrainings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usertrainingsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usertrainingsV2ControllerCreate(
    params: {
      body: WorkCreateUsertrainingDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.usertrainingsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
